( function( $, document, window ) {
	'use strict';

	$( function() {
		$('.js-category-filter').on('change', function() {
			if (this.value){
				window.location=this.value;
			}
		});
	} );
} )( jQuery, document, window );
